import React from 'react';

import { useBusinessToolSessionStore } from 'store/useBusinessToolStore';
import { getBusinessToolMode } from 'store/useBusinessToolStore/selectors';

import { checkIsPreviewMode } from 'pages/BusinessToolPage/utils';

import { BottomNavigationButtonsMobile } from 'components/BottomNavigationButtonsMobile/BottomNavigationButtonsMobile';

import { ForBankSectionsNavigation } from './ForBankSectionsNavigation';
import { TNavigationRenderFn } from '../../../types';
import { ModeSwitch } from '../../ModeSwitch/ModeSwitch';
import { ViewExampleSwitch } from '../../ViewExampleSwitch';

interface IForBankNavigationProps {
  render: TNavigationRenderFn;
}

export const ForBankNavigation: React.FC<IForBankNavigationProps> = ({ render }) => {
  const businessToolMode = useBusinessToolSessionStore(getBusinessToolMode);
  const isPreviewMode = checkIsPreviewMode(businessToolMode);

  return render({
    modeSwitch: <ModeSwitch />,
    typeSwitch: isPreviewMode && <ViewExampleSwitch />,
    sectionsNavigation: <ForBankSectionsNavigation />,
    navigationButtons: <BottomNavigationButtonsMobile />,
  });
};
